import { useEffect, useRef, useState } from 'react';
import { CAMERA_PLATFORMS, type CameraPlatformId } from '../../domain/camera-platform';
import { CAMERA_SAMPLE_FORMATS, CAMERA_SAMPLE_MAPS } from './camera-samples';
import { resolveMapStyle } from '../../domain/map-style';
import versions from './media-versions.json';
import { SampleVideoPlayer } from './SampleVideoPlayer';
import { sampleMediaId } from './sample-media';
import { CAMERA_SAMPLE_DESCRIPTIONS } from './camera-sample-descriptions';

export function CameraVideoSamples() {
  const [camera, setCamera] = useState<CameraPlatformId>('night-hawk');
  const [format, setFormat] = useState<typeof CAMERA_SAMPLE_FORMATS[number]>(CAMERA_SAMPLE_FORMATS[0]);
  const host = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const update = () => {
      const width = host.current?.clientWidth ?? innerWidth;
      const ratio = width / Math.max(240, innerHeight * .68);
      setFormat(CAMERA_SAMPLE_FORMATS.reduce((best, item) => Math.abs(Math.log(item.width / item.height / ratio)) < Math.abs(Math.log(best.width / best.height / ratio)) ? item : best));
    };
    const observer = new ResizeObserver(update); if (host.current) observer.observe(host.current);
    window.addEventListener('resize', update); update(); return () => { observer.disconnect(); window.removeEventListener('resize', update); };
  }, []);
  const id = sampleMediaId(`camera-${camera}-${format.id}`);
  const version = (versions as Record<string, string>)[id];
  const label = CAMERA_PLATFORMS.find(item => item.id === camera)!.label;
  const description = CAMERA_SAMPLE_DESCRIPTIONS[camera];
  const mapLabel = resolveMapStyle(CAMERA_SAMPLE_MAPS[camera]).label;
  return <section id="cameras" className="sample-map-gallery" aria-labelledby="camera-sample-heading">
    <h2 id="camera-sample-heading">Camera platforms in motion</h2>
    <div className="sample-map-choices" role="group" aria-label="Camera video previews">{CAMERA_PLATFORMS.map(item => <button type="button" key={item.id} aria-pressed={camera === item.id} onClick={() => setCamera(item.id)}>{item.label}</button>)}</div>
    <p><strong>Platform:</strong> {description.platform} <strong>This sample:</strong> {description.sample}</p>
    <div ref={host}><SampleVideoPlayer key={id} src={`/samples/${id}.mp4${version ? `?v=${version}` : ''}`} width={format.width} height={format.height}
      playbackRate={camera === 'blackbird' ? 0.25 : camera === 'chase' ? 0.75 : 1} label={label} description={`${label}. ${description.platform} This sample: ${description.sample}`} /></div>
    <p className="sample-caption">{label} Camera Platform · {mapLabel} map · 30 seconds · {format.width} × {format.height}</p>
  </section>;
}
